// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"style_mainDiv__3jMfr","splashLogo":"style_splashLogo__xbQHF"};